/* v4 landing: gallery, quantity, add-to-cart (/cart/add.js), sticky bar, story map,
   FAQ accordion, lightbox, and date maths. No fake counters, no timers. */
(function () {
  'use strict';
  if (window.__v4Landing) return;
  window.__v4Landing = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var dateFmt;
  try { dateFmt = new Intl.DateTimeFormat(document.documentElement.lang || undefined, { weekday: 'short', month: 'short', day: 'numeric' }); }
  catch (e) { dateFmt = new Intl.DateTimeFormat('en', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return dateFmt.format(d); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Lightbox ---------- */
  var lb = document.querySelector('[data-v4-lightbox]');
  var lbImg = lb && lb.querySelector('[data-v4-lightbox-img]');
  var lbCap = lb && lb.querySelector('[data-v4-lightbox-cap]');
  var lbReturn = null;
  function openLightbox(src, alt, cap, trigger) {
    if (!lb || typeof lb.showModal !== 'function') { window.open(src, '_blank', 'noopener'); return; }
    lbImg.src = src; lbImg.alt = alt || ''; lbCap.textContent = cap || '';
    lbReturn = trigger || null;
    lb.showModal();
  }
  if (lb) {
    lb.addEventListener('close', function () { if (lbReturn) lbReturn.focus(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    var closeBtn = lb.querySelector('[data-v4-lightbox-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { lb.close(); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-v4-lb-src]');
    if (!t) return;
    openLightbox(t.getAttribute('data-v4-lb-src'), t.getAttribute('data-v4-lb-alt'), t.getAttribute('data-v4-lb-cap'), t);
  });

  /* ---------- Gallery ---------- */
  $all('[data-v4-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-v4-main]');
    var thumbs = $all('[data-v4-thumb]', g);
    var current = thumbs[0];
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (!main) return;
        main.src = t.dataset.src; main.srcset = t.dataset.srcset; main.alt = t.dataset.alt;
        thumbs.forEach(function (o) { o.setAttribute('aria-current', o === t ? 'true' : 'false'); });
        current = t;
      });
    });
    var zoom = g.querySelector('[data-v4-zoom]');
    if (zoom && main) zoom.addEventListener('click', function () {
      var full = current ? current.dataset.full : main.currentSrc || main.src;
      openLightbox(full, main.alt, main.alt, zoom);
    });
  });

  /* ---------- Buy box ---------- */
  var form = document.querySelector('[data-v4-form]');
  var sticky = document.querySelector('[data-v4-sticky]');
  if (form) {
    var priceEl = form.closest('.v4-buy').querySelector('[data-v4-price]');
    var unitPrice = priceEl ? priceEl.textContent : '';
    var stickyPrice = sticky && sticky.querySelector('[data-v4-sticky-price]');
    var stickyLabel = sticky && sticky.querySelector('[data-v4-sticky-label]');
    var addBtn = form.querySelector('[data-v4-add]');
    var errEl = form.querySelector('[data-v4-error]');
    var goCheckout = !!form.querySelector('input[name="return_to"]');

    function selectedQty() {
      var r = form.querySelector('[data-v4-qty]:checked');
      return r || null;
    }
    function syncQty() {
      var r = selectedQty();
      if (!r) return;
      if (stickyPrice) stickyPrice.textContent = r.dataset.total;
      if (stickyLabel) stickyLabel.textContent = r.dataset.label;
      if (priceEl) priceEl.textContent = r.value === '1' ? unitPrice : r.dataset.total;
    }
    $all('[data-v4-qty]', form).forEach(function (r) { r.addEventListener('change', syncQty); });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // native POST fallback to /cart/add
      e.preventDefault();
      if (addBtn.disabled) return;
      var qtyInput = selectedQty() || form.querySelector('input[name="quantity"]');
      var id = parseInt(form.querySelector('[data-v4-variant]').value, 10);
      var qty = parseInt(qtyInput ? qtyInput.value : '1', 10) || 1;
      addBtn.disabled = true; addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true');
      errEl.textContent = '';
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      }).then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      }).then(function (r) {
        if (!r.ok) throw new Error((r.data && (r.data.description || r.data.message)) || 'Could not add to cart.');
        window.location.href = goCheckout ? root + 'checkout' : root + 'cart';
      }).catch(function (err) {
        errEl.textContent = err.message + ' Please try again, or email us if it keeps happening.';
        addBtn.disabled = false; addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy');
      });
    });

    // Proxies (sticky bar, final CTA) submit the real form with the chosen quantity.
    document.addEventListener('click', function (e) {
      var p = e.target.closest('[data-v4-add-proxy]');
      if (!p) return;
      e.preventDefault();
      if (typeof form.requestSubmit === 'function') form.requestSubmit(); else addBtn.click();
    });

    // Sticky buy bar: always visible on every device.
    if (sticky) {
      var stickyBtn = sticky.querySelector('button');
      var ticking = false, shown = null;
      var update = function () {
        ticking = false;
        var show = true;
        if (show === shown) return;
        shown = show;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
      update();
    }
  }

  /* ---------- Real dates ---------- */
  var today = new Date();
  $all('[data-v4-shipwindow]').forEach(function (el) {
    var a = parseInt(el.dataset.min, 10), b = parseInt(el.dataset.max, 10);
    if (!a || !b) return;
    el.textContent = 'Order today: ships with tracking between ' + fmt(addDays(today, a)) + ' and ' + fmt(addDays(today, b)) + ', delivered in 7–14 days.';
  });
  $all('[data-v4-date]').forEach(function (el) { el.textContent = 'Today, ' + fmt(addDays(today, parseInt(el.dataset.v4Date, 10) || 0)); });
  $all('[data-v4-date-range]').forEach(function (el) {
    var p = el.getAttribute('data-v4-date-range').split(',');
    el.textContent = 'About ' + fmt(addDays(today, parseInt(p[0], 10))) + ' to ' + fmt(addDays(today, parseInt(p[1], 10)));
  });
  $all('[data-v4-deadline]').forEach(function (el) {
    var md = (el.dataset.holiday || '').split('-');
    var m = parseInt(md[0], 10), d = parseInt(md[1], 10);
    if (!m || !d) return;
    var prod = parseInt(el.dataset.prod, 10) || 0, ship = parseInt(el.dataset.ship, 10) || 0;
    var holiday = new Date(today.getFullYear(), m - 1, d);
    var orderBy = addDays(holiday, -(prod + ship));
    var t0 = addDays(today, 0);
    if (orderBy < t0) { // this year's date has passed: only show if next year's is relevant (it isn't, keep hidden)
      el.hidden = true; return;
    }
    var daysLeft = Math.round((orderBy - t0) / 86400000);
    el.innerHTML = '';
    var s = document.createElement('strong');
    s.textContent = 'Ordering for ' + (el.dataset.name || 'the holidays') + '? Order by ' + fmt(orderBy) + '.';
    el.appendChild(s);
    el.appendChild(document.createTextNode(' Delivery takes up to ' + (prod + ship) + ' days' + (daysLeft <= 21 ? ' (' + daysLeft + (daysLeft === 1 ? ' day' : ' days') + ' from today).' : '.')));
    el.hidden = false;
  });

  /* ---------- Story map ---------- */
  $all('[data-v4-map]').forEach(function (map) {
    var items = $all('[data-v4-scene]', map), pins = $all('[data-v4-pin]', map);
    function activate(n) {
      items.forEach(function (i) { i.classList.toggle('is-active', i.dataset.v4Scene === n); });
      pins.forEach(function (p) { p.classList.toggle('is-active', p.dataset.v4Pin === n); });
    }
    items.forEach(function (i) {
      ['mouseenter', 'focusin', 'click'].forEach(function (ev) { i.addEventListener(ev, function () { activate(i.dataset.v4Scene); }); });
    });
    pins.forEach(function (p) {
      p.addEventListener('mouseenter', function () { activate(p.dataset.v4Pin); });
      p.addEventListener('click', function () { activate(p.dataset.v4Pin); });
    });
    if (items[0]) activate(items[0].dataset.v4Scene);
  });

  /* ---------- FAQ ---------- */
  $all('[data-v4-faq] .v4-faq__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = open;
    });
  });

  if (reduce) document.documentElement.classList.add('v4-reduced');
})();
